import { Component, Vue } from 'vue-property-decorator'
import api from '@/helpers/fetch'
import date from '@/helpers/date'
import Loader from '@/components/Loader/index.vue'

@Component({
	components: {
		Loader,
	},
})
export default class VacationContent extends Vue {
	loading = false
	vacations = [] as any[]

	async mounted() {
		this.loading = true
		const res = await api.get('/api/my-account/vacations')
		if (res.ok) {
			this.vacations = []
			this.vacations = res.data
		}
		this.loading = false
	}

	shortDate(datestring) {
		if (!datestring) return ''
		return date.shortDate(datestring)
	}

	daysUntil(datestring) {
		return date.daysUntil(datestring)
	}

	firstVacationDay(datestring) {
		if (!datestring) return ''
		return this.shortDate(
			new Date(datestring).getTime() - 1000 * 60 * 60 * 24 * 90,
		)
	}
}
